import React, { useEffect } from 'react';

// The dialog the Queue and Residents tabs open: a title and an X, a body that scrolls on its own and a pinned footer with Refresh and Close. Escape and a
// click outside close it, so it never traps anyone.
export default function JobShell({ title, ariaLabel, onClose, onRefresh, children }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className="v2-dialog-host v2-job-host" role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="v2-dialog v2-job-dialog" role="dialog" aria-label={ariaLabel}>
        <header className="v2-job-head">
          <h2>{title}</h2>
          <button type="button" className="v2-iconbtn" aria-label="Close dialog" onClick={onClose}>&times;</button>
        </header>
        <div className="v2-job-body">{children}</div>
        <footer className="v2-job-foot">
          <button type="button" className="v2-btn" onClick={onRefresh}>Refresh</button>
          <button type="button" className="v2-btn primary" onClick={onClose}>Close</button>
        </footer>
      </div>
    </div>
  );
}
